import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';

export function AddOptionButton({
	onAddOption,
	onAddOther,
	showCheckbox = false,
	hideOther = false,
	hideCircle = false,
}: {
	onAddOther: () => void;
	onAddOption: () => void;
	showCheckbox?: boolean;
	hideOther?: boolean;
	hideCircle?: boolean;
}) {
	return (
		<Button
			variant={'ghost'}
			className="flex w-72 max-w-full cursor-default items-center justify-start gap-3 p-3 px-0 text-slate-400 hover:bg-transparent"
		>
			{showCheckbox ? (
				<Checkbox
					className="h-5 w-5 rounded-[2px] border-2 border-slate-400 disabled:opacity-100"
					disabled
				/>
			) : !hideCircle ? (
				<span className="h-5 w-5 rounded-[9999px] border-2 border-slate-400"></span>
			) : null}
			<p className="cursor-pointer text-base font-normal leading-6 text-slate-400">
				<button
					className="group relative inline border-none py-1 pr-2 text-slate-400 outline-none"
					onClick={onAddOption}
				>
					Add option
					<span className="absolute bottom-[-2px] left-0 right-2 hidden h-[1px] bg-slate-400 group-hover:block"></span>
				</button>
				{hideOther ? null : (
					<>
						<span className="mx-1 text-black">or</span>
						<button
							className="inline rounded border-none px-2 py-1 text-primary-blue outline-none transition-colors hover:bg-blue-50"
							onClick={onAddOther}
						>
							add &ldquo;Other&rdquo;
						</button>
					</>
				)}
			</p>
		</Button>
	);
}
